export type WebpWidth = WebpWidthEnum | WebpHeightEnum | ThumbnailWidth | BackgroundWidth;

export enum WebpWidthEnum {
    WIDTH_1800 = 1800,
    WIDTH_1200 = 1200,
    WIDTH_900 = 900,
    WIDTH_450 = 450,
    WIDTH_225 = 225,
    WIDTH_110 = 110,
}

/**
 * WARNING: only use with WIDTH 1200 due to limitations in the webp-server
 */
export enum WebpHeightEnum {
    HEIGHT_1200 = 1200,
    HEIGHT_900 = 900,
}

export enum ThumbnailWidth {
    WIDTH_225 = 225,
    WIDTH_110 = 110,
    WIDTH_90 = 90,
    WIDTH_62 = 62,
    WIDTH_48 = 48,
}

export enum BackgroundWidth {
    WIDTH_1200 = 1200,
    WIDTH_900 = 900,
    WIDTH_450 = 450,
}

export const webpWidths: WebpWidth[] = Object.values(WebpWidthEnum).filter(
    (item) => !isNaN(Number(item)),
) as WebpWidth[];
